import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { capitalize } from "@mui/material";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { FilteredAsgResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";

export const asgColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef(),

  resourceAccountColumnDef,

  resourceTotalSpendColumnDef,

  { field: "resource.instances_count", headerName: "Instances" },
  { field: "resource.desired_capacity", headerName: "Desired Capacity" },
  { field: "resource.max_capacity", headerName: "Max" },
  { field: "resource.min_capacity", headerName: "Min" },

  {
    field: "resource.public_ip",
    headerName: "Public IP",
    headerTooltip:
      "Checks if Auto Scaling groups have public IP addresses enabled through their Launch Configurations.",
    cellRenderer: ({ data }: ICellRendererParams<FilteredAsgResourceItem>) => {
      const value = data?.resource?.public_ip;

      return value ? capitalize(value) : "-";
    },
  },

  getResourceCreationTimeColumnDef("Launch time"),

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
